let deferredInstallPrompt = null;
let installButton = null;

const isStandaloneMode = () => {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
};

const removeInstallButton = () => {
  if (installButton && installButton.parentNode) {
    installButton.parentNode.removeChild(installButton);
  }
  installButton = null;
};

const ensureInstallButton = () => {
  if (installButton || isStandaloneMode()) {
    return;
  }

  installButton = document.createElement('button');
  installButton.type = 'button';
  installButton.textContent = 'Instalar app';
  installButton.setAttribute('aria-label', 'Instalar ANW');
  installButton.style.position = 'fixed';
  installButton.style.right = '16px';
  installButton.style.bottom = '16px';
  installButton.style.zIndex = '9999';
  installButton.style.padding = '10px 14px';
  installButton.style.border = 'none';
  installButton.style.borderRadius = '999px';
  installButton.style.backgroundColor = '#295f9f';
  installButton.style.color = '#ffffff';
  installButton.style.fontWeight = '600';
  installButton.style.boxShadow = '0 6px 16px rgba(0,0,0,0.2)';
  installButton.style.cursor = 'pointer';

  installButton.addEventListener('click', async () => {
    if (!deferredInstallPrompt) {
      return;
    }

    deferredInstallPrompt.prompt();
    await deferredInstallPrompt.userChoice;
    deferredInstallPrompt = null;
    removeInstallButton();
  });

  document.body.appendChild(installButton);
};

window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault();
  deferredInstallPrompt = event;
  ensureInstallButton();
});

window.addEventListener('appinstalled', () => {
  deferredInstallPrompt = null;
  removeInstallButton();
});
